import { pixelate, removeSolidBackground } from "./pixelate";

const ICON_SIZE = 16;

export async function toIconDataUrl(pngBase64: string): Promise<string> {
  const img = await loadImage(`data:image/png;base64,${pngBase64}`);
  if (img.width === ICON_SIZE && img.height === ICON_SIZE) return drawToDataUrl(img);
  const source = document.createElement("canvas");
  source.width = img.width;
  source.height = img.height;
  const ctx = source.getContext("2d", { willReadFrequently: true })!;
  ctx.drawImage(img, 0, 0);
  const raw = ctx.getImageData(0, 0, img.width, img.height);
  const icon = pixelate(removeSolidBackground({ width: raw.width, height: raw.height, data: raw.data }));
  const out = document.createElement("canvas");
  out.width = ICON_SIZE;
  out.height = ICON_SIZE;
  out.getContext("2d")!.putImageData(new ImageData(new Uint8ClampedArray(icon.data), ICON_SIZE, ICON_SIZE), 0, 0);
  return out.toDataURL("image/png");
}

function drawToDataUrl(img: HTMLImageElement): string {
  const canvas = document.createElement("canvas");
  canvas.width = ICON_SIZE;
  canvas.height = ICON_SIZE;
  canvas.getContext("2d")!.drawImage(img, 0, 0);
  return canvas.toDataURL("image/png");
}

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("could not read picture"));
    img.src = src;
  });
}
